import { SLUG_ADJECTIVES, SLUG_NOUNS, SLUG_NUMBER_DIGITS, SLUG_NUMBER_MAX, SLUG_NUMBER_MIN, } from './tenant-slug.constants.js';
const UINT32_RANGE = 0x1_0000_0000;
export const cryptoRandomInt = (min, max) => {
    // This package compiles with `types: []` (no DOM or Node typings), so the global Web
    // Crypto object is not declared; it exists at runtime in Node 20+ and every browser.
    const { crypto } = globalThis;
    const range = max - min + 1;
    const limit = UINT32_RANGE - (UINT32_RANGE % range);
    const sample = new Uint32Array(1);
    do {
        crypto.getRandomValues(sample);
    } while (sample[0] >= limit);
    return min + (sample[0] % range);
};
export function generateTenantSlug(randomInt = cryptoRandomInt) {
    const adjective = SLUG_ADJECTIVES[randomInt(0, SLUG_ADJECTIVES.length - 1)];
    const noun = SLUG_NOUNS[randomInt(0, SLUG_NOUNS.length - 1)];
    const suffix = randomInt(SLUG_NUMBER_MIN, SLUG_NUMBER_MAX);
    return `${adjective}-${noun}-${suffix}`;
}
const GENERATED_SLUG_PATTERN = new RegExp(`^([a-z]+)-([a-z]+)-(\\d{${SLUG_NUMBER_DIGITS}})$`);
const ADJECTIVE_SET = new Set(SLUG_ADJECTIVES);
const NOUN_SET = new Set(SLUG_NOUNS);
export function isGeneratedTenantSlug(slug) {
    const match = GENERATED_SLUG_PATTERN.exec(slug);
    if (!match)
        return false;
    const [, adjective, noun, suffix] = match;
    const suffixNumber = Number(suffix);
    return (ADJECTIVE_SET.has(adjective) &&
        NOUN_SET.has(noun) &&
        suffixNumber >= SLUG_NUMBER_MIN &&
        suffixNumber <= SLUG_NUMBER_MAX);
}
//# sourceMappingURL=tenant-slug.js.map